import React from "react";
import { Row, Col, Typography, Card } from "antd";
import footballImg from "../../assets/football.png";
import nellab1 from "../../assets/nellab1.jpg";
import nellab2 from "../../assets/nellab2.jpg";
import p1 from "../../assets/p1.jpg";
import p2 from "../../assets/p2.jpg";
import p3 from "../../assets/p3.png";
import p4 from "../../assets/p4.jpg";
import downloadIcon from "../../assets/download.png";

const { Title, Paragraph } = Typography;

export default function FootballAbout() {
  const upcomingEvents = [
    {
      img: nellab1,
      name: "Nellab 1",
      text: "Nellab 1 is our open tournament for amateur players who play for passion, not fame. Anyone can join",
      date: "Event Completed",
      tagText: "Event Completed",
    },
    {
      img: nellab2,
      name: "Nellab 2",
      text: "Nellab 2 is our open tournament for amateur players who play for passion, not fame. Anyone can join",
      date: "25 - Nov - 2025",
      tagText: "Registration will open soon",
    },
  ];

  const pastHighlights = [p1, p2, p3, p4];

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "transparent",
    padding: "60px 0",
    marginTop: "-70px",
  };

  const sectionStyle = {
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto 80px auto",
    padding: "0 40px",
  };

  const headingStyle = {
    fontSize: "32px",
    fontWeight: "700",
    color: "#000",
    marginBottom: "40px",
    textAlign: "left",
    paddingLeft: "0",
  };

  const contentStyle = {
    fontSize: "16px",
    color: "#333",
    lineHeight: "1.8",
    textAlign: "left",
    marginLeft: "0",
  };

  return (
    <div style={containerStyle}>

      {/* About Section */}
      <div style={sectionStyle}>
        <Card
          style={{ 
            border: "none", 
            borderRadius: "16px",
          }}
        >
          <Row gutter={[48, 32]} align="middle">
            <Col xs={24} md={12}>
              <div style={{ paddingRight: "20px" }}>
                <Title 
                  level={2} 
                  style={{ 
                    color: "#480558", 
                    textAlign: "left",
                    marginBottom: "24px",
                    fontSize: "28px",
                    fontWeight: "700",
                  }}
                >
                  About the Football Tournaments
                </Title>
                <Paragraph style={contentStyle}>
                  Yalla Nellab hosts friendly and competitive football tournaments
                  for workers, companies, schools and open-community teams.
                  Whether you're a weekend player or a trained athlete, our
                  football events give everyone a chance to play, connect and
                  grow.
                </Paragraph>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <img
                src={footballImg}
                alt="Football"
                style={{
                  width: "70%",
                  borderRadius: "12px",
                  objectFit: "cover",
                  marginLeft: "100px",
                }}
              />
            </Col>
          </Row>
        </Card>
      </div>

      {/* Upcoming Tournaments Section */}
      <div style={sectionStyle}>
        <h2 style={headingStyle}>
          Upcoming Tournaments
        </h2>

        <div
          style={{
            display: "flex",
            gap: "40px",
            overflowX: "auto",
            flexWrap: "nowrap",
            paddingBottom: "20px",
          }}
        >
          {upcomingEvents.map((event, idx) => (
            <div
              key={idx}
              style={{
                flex: "0 0 480px",
                textAlign: "left",
                overflow: "hidden",
                backgroundColor: "#f8f8f8",
                boxShadow: "0 2px 12px rgba(0,0,0,0.1)",
                display: "flex",
                flexDirection: "column",
                borderRadius: "12px",
              }}
            >
              <img
                src={event.img}
                alt={event.name}
                style={{
                  width: "100%",
                  height: "280px",
                  objectFit: "cover",
                }}
              />
              <div style={{ padding: "24px" }}>
                <h4 style={{ 
                  fontSize: "20px", 
                  fontWeight: "600", 
                  color: "#1C1C1C", 
                  marginBottom: "12px" 
                }}>
                  {event.name}
                </h4>
                <p style={{ 
                  fontSize: "15px", 
                  color: "#333", 
                  lineHeight: "1.5", 
                  marginBottom: "16px" 
                }}>
                  {event.text}
                </p>
                <div style={{ textAlign: "center" }}>
                  <span
                    style={{
                      display: "inline-block",
                      backgroundColor: "#fff",
                      color: "#666",
                      padding: "8px 16px",
                      fontSize: "14px",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                    }}
                  >
                    {event.tagText}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Past Tournaments Highlights Section */}
      <div style={sectionStyle}>
        <h2 style={headingStyle}>
          Past Tournaments Highlights
        </h2>

        <div
          style={{
            display: "flex",
            gap: "24px",
            flexWrap: "wrap",
            justifyContent: "flex-start",
          }}
        >
          {pastHighlights.map((img, idx) => (
            <div 
              key={idx} 
              style={{ 
                flex: "0 0 calc(25% - 18px)",
                minWidth: "250px"
              }}
            >
              <img
                src={img}
                alt={`Past Highlight ${idx + 1}`}
                style={{
                  width: "100%",
                  height: "220px",
                  objectFit: "cover",
                  borderRadius: "12px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Tournament Structure Section */}
      <div style={sectionStyle}>
        <h2 style={headingStyle}>
          Tournament Structure
        </h2>
        <div style={contentStyle}>
          1. All matches follow the 11-a-side format, played under standard football rules.<br />
          2. Teams are divided into groups, with top teams advancing to the knockout stage.<br />
          3. Each match consists of two halves of 45 minutes, with a 10-minute halftime break.<br />
          4. Players must present a valid ID at the venue for verification before kick-off.<br />
          5. Fair play, teamwork and discipline are strictly enforced — violations may lead to suspension or disqualification.
        </div>
      </div>

      {/* Download Rule Book Button */}
      <div style={{...sectionStyle, marginBottom: "40px" }}>
        <button
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            padding: "16px 24px",
            width: "300px",
            backgroundColor: "#ffffff", 
            color: "#000000", 
            fontSize: "16px",
            fontWeight: "600",
            border: "2px solid #A3A3A3",
            borderRadius: "8px",
            cursor: "pointer",
            marginLeft: "0",
          }}
          onClick={() => {}}
        >
          <img
            src={downloadIcon}
            alt="Download Icon"
            style={{ width: "24px", height: "24px" }}
          />
          <span>Download Rule Book</span>
        </button>
      </div>

    </div>
  );
}